var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.group)?_c('div',{staticClass:"group-view"},[(
      _vm.currentQuestionGroup &&
      _vm.currentQuestionGroup.subjects &&
      _vm.currentQuestionGroup.subjects.length > 0
    )?_c('div',{staticClass:"subjects-container"},[_c('StaggeredFadeTransition',{attrs:{"class-name":"ll-link-list","tag":"ul","delay":50}},_vm._l((_vm.currentQuestionGroup.subjects),function(s,index){return _c('li',{key:s.id,attrs:{"data-index":index}},[_c('RouterLink',{staticClass:"item",attrs:{"to":'/' +
            _vm.currentQuestionClass.slug +
            '/' +
            _vm.currentQuestionGroup.slug +
            '/' +
            s.slug}},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar-container"},[_c('div',{staticClass:"progress-bar-fill",style:('width: ' +
                  (s.question_counts.counted_answered /
                    s.question_counts.total) *
                    100 +
                  '%;')})]),_c('div',{staticClass:"count"},[_vm._v("\n              "+_vm._s(s.question_counts.counted_answered)+" /\n              "+_vm._s(s.question_counts.total)+"\n            ")])]),_c('p',{staticClass:"name"},[_vm._v(_vm._s(s.subject_name))])])],1)}),0)],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }